export default __webpack_public_path__ + "static/service-details-8dad48a356bc92b646060d62b2cb6f97.jpg";